<template>
  <div class="responsive-table">
    <table class="filelist" >
      <thead>
        <tr>
          <th></th>
          <th v-for="target in targets" :key="target">
            {{ target }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="{uri, statusByTarget} in copyPages" :key="uri">
          <th class="col-uri">{{ uri }}</th>
          <td v-for="target in targets" :key="target">
            {{ LANG[statusByTarget[target]] }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import fetchService from '@/utils/model/fetch_service';

export default defineComponent({
  props: ['nodeId'],
  data: () => ({
    info: Object,
    targets: [],
    copyPages: [],
  }),
  async created() {
    const response = await fetchService.GetData('docbrowser_publish_status', { __imperia_node_id: this.nodeId });

    this.targets = response.data.targets_list;
    const publishedStatus = response.data && response.data.published_state;

    // FIXME: remove this mapping; use the statusCode + prefix as a translation key
    const translations = {
      ok: 'upToDateStatus',
      'n/a': 'notAvailable',
      deleted: 'unpublished',
      old: 'updatePending',
    };

    // FIXME: the back-end response comes in a weird shape so we normalize it
    // TODO: fix the end-point response re: better data format
    this.copyPages = publishedStatus.map(
      ([uri, statusInfos]) => ({
        uri,
        statusByTarget: Object.fromEntries(
          statusInfos
            .map(({ type: statusCode }, i) => [this.targets[i], statusCode])
            .map(([target, code]) => [target, translations[code]]),
        ),
      }),
    );
  },
  computed: {
    ...mapState(['LANG']),
  },
});
</script>

<style scoped lang='scss'>
.filelist {
  min-width: 100%;
  th, td {
    white-space: nowrap;
    padding-right: 15px;
  }
  th {
    font-weight: bold;
    font-size: 13px;
    font-family: $font-family-regular;
  }
}
.col-uri {
  max-width: 360px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
